module.exports = __webpack_public_path__ + "static/media/lucky-wheel-img-8.5ff80e97.png";